<template>
  <div class="nt-navegable-image">
    <slot name="title"></slot>
    <div class="img-wrapper lazyload" :data-bg="this.img">
      <img :data-src="this.img" :alt="this.alt" class="navigable-image image normal-zoom lazyload">
    </div>
  </div>
</template>

<script>
export default {
  name: 'NtNavegableImage',
  props: {
    img: {
      type: String,
      required: true
    },
    imagezoom: {
      type: String,
      default: '1.8'
    },
    alt: {
      type: String
    }
  },
  data() {
    return {
      //
    }
  },
  mounted() {
    this.zoom()
  },
  methods: {
    zoom() {
      const elementsNavImg = document.querySelectorAll('.navigable-image')
      for (let i = 0; i < elementsNavImg.length; i++) {
        elementsNavImg[i].addEventListener('mousemove', (event) => {
          const bbox = event.target.getBoundingClientRect()
          const mouseX = event.clientX - bbox.left
          const mouseY = event.clientY - bbox.top
          const xPercent = (mouseX / bbox.width) * 100
          const yPercent = (mouseY / bbox.height) * 100
          elementsNavImg[i].style.transformOrigin = (xPercent + '%' + yPercent + '%') // eslint-disable-line
        })
        elementsNavImg[i].addEventListener('mouseenter', () => {
          elementsNavImg[i].classList.add('zoom-in')
          elementsNavImg[i].classList.remove('normal-zoom')
          elementsNavImg[i].style.transform = `scale(${this.imagezoom})`
        })
        elementsNavImg[i].addEventListener('mouseleave', () => {
          elementsNavImg[i].classList.add('normal-zoom')
          elementsNavImg[i].classList.remove('zoom-in')
        })
      }
    }
  }
}
</script>
